// Utility to centralize determination of the default post-login destination.
// Currently replicates existing behavior: dashboard route name or '/dashboard'.
// Future: if backend supplies dynamic landing info, wire it here.
export function getDefaultAdminLandingRoute () {
	return '/dashboard'
}

// Placeholder risk portal access flag (to be replaced with real permission check later)
